import { render, staticRenderFns } from "./FangfengjiDetails.vue?vue&type=template&id=7c371401"
import script from "./FangfengjiDetails.vue?vue&type=script&lang=js"
export * from "./FangfengjiDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports